import React from "react";
import { IBillingCompanyContextState } from "./BillingCompanyProvider.types";
import { defaultBillingCompanyContextState } from "./BillingCompanyProvider.state";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { BillingCompanyContext } from "./BillingCompanyProvider.context";
import { fetchBillingCompanyInfoAsync } from "./BillingCompanyProvider.services";
import { LinearProgress } from "@mui/material";
import { NoBillingComapnyScreen } from "./views/NoBillingComapnyScreen";
import { saveBillingCompanyInStorage } from "./BillingCompanyProvider.storage";

export const BillingCompanyProvider: React.FC<{ children: React.ReactNode }> = (
  props,
) => {
  const [outletInfo, setOutletInfo] =
    React.useState<IBillingCompanyContextState>(
      defaultBillingCompanyContextState,
    );
  const [loading, setLoading] = React.useState(false);
  const [zeroOutletDialog, setZeroOutletDialog] =
    React.useState<boolean>(false);

  const { userInfo } = useAuth();
  console.log("userInfo ==>", userInfo);
  const { role_value, user_uuid, affiliated_billing_company_uuids } =
    userInfo.user;

  const isAdmin =
    role_value === "ADMIN" ||
    role_value === "SUPERADMIN" ||
    role_value === "ENR_ADMIN";

  React.useEffect(() => {
    if (!user_uuid) return;
    getOutDetails();
  }, [user_uuid]);

  const getOutDetails = async () => {
    setLoading(true);
    const validCompany = await fetchBillingCompanyInfoAsync(
      affiliated_billing_company_uuids,
    );
    if (validCompany) {
      saveBillingCompanyInStorage(validCompany.comapny);
      setOutletInfo(validCompany);
    } else {
      setZeroOutletDialog(true);
    }
    setLoading(false);
  };

  if (loading) return <LinearProgress />;

  if (!isAdmin && user_uuid && zeroOutletDialog)
    return <NoBillingComapnyScreen />;

  return (
    <BillingCompanyContext.Provider value={outletInfo}>
      {props.children}
    </BillingCompanyContext.Provider>
  );
};
